// extracted by mini-css-extract-plugin
module.exports = {"BestSelling":"BestSelling_BestSelling__XAnf1"};